import React from "react";
import { Trophy, Lock } from "lucide-react";
import { eur, ComBadge } from "@/components/bp/EarningsBoard";

/** Jauge des paliers de ventes du trimestre (portail BP + fiche admin). */
export const TiersGauge = ({ tiers, compact = false }) => {
  if (!tiers || !tiers.enabled || !(tiers.tiers || []).length) return null;
  const max = Math.max(...tiers.tiers.map((t) => t.sales), 1);
  const pct = Math.min(100, Math.round((tiers.sales / max) * 100));
  return (
    <div className="bg-white border border-[#DEE2E6] p-4 space-y-3" data-testid="bp-earn-tiers">
      <div className="flex flex-wrap items-center gap-2">
        <Trophy className="h-4 w-4 text-[#F59E0B]" />
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold">Paliers du trimestre · {tiers.quarter_label}</div>
        <div className="ml-auto text-xs"><b className="font-display font-black text-base" data-testid="bp-earn-tiers-sales">{tiers.sales}</b> vente{tiers.sales > 1 ? "s" : ""} validée{tiers.sales > 1 ? "s" : ""}{tiers.earned_bonus > 0 && <span className="ml-2 text-[#059669] font-bold" data-testid="bp-earn-tiers-earned">+{eur(tiers.earned_bonus)} de bonus</span>}</div>
      </div>
      <div className="relative h-3 bg-[#F1F3F5]">
        <div className="absolute inset-y-0 left-0 bg-[#F59E0B] transition-[width] duration-700" style={{ width: `${pct}%` }} data-testid="bp-earn-tiers-bar" />
        {tiers.tiers.map((t) => <div key={t.sales} className={`absolute -top-1 h-5 w-0.5 ${t.reached ? "bg-[#059669]" : "bg-[#868E96]"}`} style={{ left: `calc(${Math.min(100, (t.sales / max) * 100)}% - 1px)` }} />)}
      </div>
      <div className={`grid gap-2 ${compact ? "grid-cols-3" : "grid-cols-3 md:grid-cols-5"}`}>
        {tiers.tiers.map((t) => (
          <div key={t.sales} className={`p-2 border text-xs ${t.reached ? "border-[#A7F3D0] bg-[#ECFDF5]" : "border-[#DEE2E6] bg-[#F8F9FA] text-[#868E96]"}`} data-testid={`bp-tier-${t.sales}`} data-reached={t.reached ? "1" : "0"}>
            <div className="flex items-center justify-between gap-1"><span className="font-bold">{t.sales} ventes</span>{!t.reached && <Lock className="h-3 w-3" />}</div>
            <div className="font-display font-black text-sm">{eur(t.bonus)}</div>
            {t.bonus_status && <ComBadge status={t.bonus_status} testid={`bp-tier-status-${t.sales}`} />}
          </div>
        ))}
      </div>
      <div className="text-[10px] text-[#495057]" data-testid="bp-earn-tiers-next">
        {tiers.next ? <>Encore <b>{tiers.next.remaining}</b> vente{tiers.next.remaining > 1 ? "s" : ""} validée{tiers.next.remaining > 1 ? "s" : ""} avant le palier {tiers.next.sales} ventes (<b>+{eur(tiers.next.bonus)}</b>).</> : <>Tous les paliers du trimestre sont atteints — félicitations !</>}
        {" "}Ventes comptées : commissions validées ou versées sur le trimestre civil ; chaque bonus est validé par PAG puis versé avec le lot suivant.
      </div>
    </div>
  );
};
